const ToggleSwitch = ({ checked, onChange, disabled = false, title }) => {
  return (
    <label className="toggle-switch" title={title}>
      <input type="checkbox" checked={checked} onChange={onChange} disabled={disabled} />
      <span className="toggle-slider" />
    </label>
  );
};

export default ToggleSwitch;